import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import styles from './ConfirmDialog.style';

const ConfirmDialog = props => {

    const {
        classes,
        title,
        children,
        id,
        open,
        setOpen,
        onConfirm
    } = props;

    return (
        <Dialog
            open={open}
            id={id}
            onClose={() => setOpen(false)}
            aria-labelledby="confirm-dialog"
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle id="confirm-dialog" className={classes.dialogHeader}>{title}</DialogTitle>
            <DialogContent className={classes.dialogBody}>{children}</DialogContent>
            <DialogActions className={classes.dialogFooter}>
                <Button
                    id="okBtn"
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                    className={classes.okButton}
                >
                    Ok
                </Button>
                <Button
                    id="cancelBtn"
                    variant="contained"
                    onClick={() => setOpen(false)}
                    className={classes.cancelButton}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(ConfirmDialog);
